module.exports = __webpack_public_path__ + "img/activity_btn.db2e1aa1.png";